import { BASE_URL, FALLBACK_IMAGE_ID, IMAGES_SIZES } from './constants';
const getImageIdFromSize = (size) => IMAGES_SIZES.find(object => object.width === Number(size))?.imageId ||
    undefined;
export const getCloudinaryImageUrl = (imageBaseUrl, size) => {
    const imageId = getImageIdFromSize(size) || FALLBACK_IMAGE_ID;
    return `${BASE_URL}/t_$_${imageId}/move/${imageBaseUrl}`;
};
